import React, { useMemo } from "react";

interface CurrentLocationProps{
    getCurrentLocation: () => Promise<{lat: number; lng: number}>
}

const useCurrentLocation = () => {
    const getCurrentLocation = () => {
        return new Promise<{
            lat: number,
            lng: number,
        }>((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    resolve({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    })
                }, (err) => {
                    reject(new Error("Não foi possível encontrar sua localização - " + err.message));
                });
            } else {
                reject(new Error("Localização não suportada"))
            }
        })
    }

    const value = useMemo<CurrentLocationProps>(() => ({
        getCurrentLocation,
    }), [])

    return value
}

export default useCurrentLocation;